import EfficiencyTable from './EfficiencyTable';

const VendorEfficiency = ({ vendor }: any) => {
  return (
    <div className="flex flex-col gap-y-5 bg-[#343434] rounded-lg p-4 pl-6 pb-6">
      <label className=" text-xs md:text-base font-normal text-white">Vendor Efficiency</label>
      <EfficiencyTable vendors={vendor} />
    </div>
  );
};

export default VendorEfficiency;
